import {TypedUseSelectorHook, useDispatch, useSelector, useStore} from "react-redux";
import {AppState} from "../AppState";
import {AppDispatch, AppStore} from "../AppStore";

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<AppState> = useSelector;

export const useAppStore = () => useStore() as AppStore;
